import { PLAN_OVERRIDES } from '../../paths'

export { PLAN_OVERRIDES, planOverridesPath } from '../../paths'

export const planOverridesTabPath = (tabKey: string) =>
  `/${PLAN_OVERRIDES}/${tabKey}`
